// extracted by mini-css-extract-plugin
module.exports = {"h1":"LandingPage_h1__1vo2_","button":"LandingPage_button__x4YHO"};